import { map, catchError, mergeMap, pluck } from 'rxjs/operators'
import { ofType, ActionsObservable, StateObservable } from 'redux-observable'
import { ReduxAction, State } from '../../../reducers/reducerType'
import trackActions from '../../../actions/tracks'
import { TrackType } from '../../../actions/tracks/trackTypes'
import { of } from 'rxjs'
import createTrack$ from './createTrack'

export default (actions$: ActionsObservable<ReduxAction>, state$: StateObservable<State>, { createTrack = createTrack$ }) => actions$.pipe(
  ofType(TrackType.CREATE_LOCAL_VIDEO_TRACK),
  pluck<ReduxAction, any>('payload'),
  mergeMap(payload =>
    createTrack(
      state$.value.room,
      payload?.deviceId || state$.value.tracks.selectedVideoDeviceID,
      state$.value.user.BTID,
      payload?.background ? payload?.background : state$.value.userSettings.presenterBackground
    ).pipe(
      map(() => trackActions.createLocalVideoTrackSuccess()),
      catchError(e => of(trackActions.createLocalVideoTrackError(e)))
    )
  )
)

